var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('i',[_vm._v(_vm._s(_vm.dictionary))])]),_c('span',{staticClass:"pl-4"},[_vm._v(_vm._s(_vm.entId))]),_c('span',{staticClass:"pl-4"},[_c('b',[_vm._v(_vm._s(_vm.entTerm))])])])}
var staticRenderFns = []

export { render, staticRenderFns }